import React, { useState, createContext } from "react";

export const AppShopContext = createContext();
/*
export const AppShopContext = createContext({
  isAppShop: false,
  setIsAppShop: () => { },
});
*/
export const AppShopContextProvider = (props) => {
  const [developerId, setDeveloperId] = useState();
  //const [loginDeveloperId, setLoginDeveloperId] = useState();
  //const [loginDeveloperName, setLoginDeveloperName] = useState();

  return (
    <AppShopContext.Provider
      value={{
        developerId, setDeveloperId,
        //loginDeveloperId, setLoginDeveloperId,
        //loginDeveloperName, setLoginDeveloperName
      }}
    >
      {props.children}
    </AppShopContext.Provider>
  )
}